import type { AgentCode, ProviderCode } from '@ambec/shared';

/** Conector LLM tal como lo entrega el backend (nunca incluye la api_key en claro). */
export interface LlmProvider {
  id: string;
  code: ProviderCode;
  name: string;
  base_url: string | null;
  api_key_hint: string;
  /** Modelo fijado para esta conexión (permite varias conexiones del mismo proveedor). */
  model: string | null;
  sensitivity_tag: string | null;
  enabled: boolean;
  created_at: string;
}

/** Asignación de cerebro por agente (N1..N5): un conector primario y uno de respaldo. */
export interface AgentConfig {
  agent_code: AgentCode;
  display_name: string | null;
  oficio: string | null;
  connector_id: string | null;
  fallback_connector_id: string | null;
  /** Espejo legacy del conector (observabilidad/evals). */
  provider_code: ProviderCode | null;
  model: string | null;
  temperature: number | null;
  max_tokens: number | null;
  context_brief: string | null;
  fallback_provider_code: ProviderCode | null;
  fallback_model: string | null;
}

/** Fila del resumen de observabilidad (por agente × modelo). */
export interface RunSummary {
  agent_code: AgentCode;
  model: string;
  runs: number;
  success_rate: number;
  tokens_in: number;
  tokens_out: number;
  est_cost: number;
  avg_latency_ms: number;
}

/** Resultado de la prueba de conexión de un conector. */
export interface TestResult {
  ok: boolean;
  message: string;
  latencyMs: number;
}

/* Clases canónicas de la guía UI (definidas en index.css). */
export const inputClass = 'campo';
export const labelClass = 'etiqueta';
